import React, { Component, createRef } from 'react';
import { Button, Typography, Box, Grid } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getCompanyName, getRemoteExplainations } from '../utils/OpenCampground_Database_Calls';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../CSS/PrintReservation.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class PrintReservation extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.state = {
            companyName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            rules: ''
        };
    }

    async componentDidMount() {
        let response = await getCompanyName(this.props.user, this.props.serverName)
        console.log(response)
        let explainations = await getRemoteExplainations(this.props.user, this.props.serverName)
        this.setState({
            companyName: response.body[0].CompanyName,
            address: response.body[0].Address,
            city: response.body[0].City,
            state: response.body[0].State_Region,
            zip: response.body[0].PostalCode,
            rules: explainations.rules
        })
    }

    handlePrint = () => {
        const printContent = this.printRef.current.innerHTML;
        const printWindow = window.open('', '', 'width=1200,height=650');

        printWindow.document.write(`
        <html>
            <head>
                <title>Print Receipt</title>
                <link rel="stylesheet" type="text/css" href="${window.location.origin}/CSS/PrintReservation.css">
                <style>
                    body {
                    font-family: Arial, sans-serif;
                    }
                    .PrintReservation {
                    width: 100%;
                    }
                    .transactionsList {
                    width: 100%;
                    }
                    .PrintReservation .printBox {
                    margin: 2% 0;
                    padding: 2%;
                    border: 1px solid black;
                    width: 65%;
                    text-align: left;
                    }
                </style>
            </head>
            <body>${printContent}</body>
        </html>
    `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }

    render() {
        const { printItem } = this.props;

        return (
            <ThemeProvider theme={theme}>
                <Grid className='PrintReservation'>
                    <Box className='infoBox'>
                        <Typography className='infoBarTypo'>
                            Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}
                        </Typography>
                        <Typography className='infoBarTypo'>
                            Username: {this.props.user}
                        </Typography>
                    </Box>

                    <Grid container direction="row" justifyContent="center">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.props.goBack}
                            style={{ marginTop: '3%' }}
                        >
                            Go Back
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePrint}
                            style={{ marginTop: '3%', marginLeft: '54%' }}
                        >
                            Print
                        </Button>
                    </Grid>

                    <Grid container direction="column" alignItems="center" ref={this.printRef}>
                        <Box className="printBox" width="80%" p={4} border={1} borderRadius={2}>
                            <Typography variant="h5" align="center" fontWeight="bold">
                                {this.state.companyName}
                            </Typography>
                            <Typography align="center">
                                {this.state.companyAddress}
                                <br />
                                {/* Phone: {this.state.companyPhone} | Email: {this.state.companyEmail} */}
                                Address: {this.state.address}, {this.state.city}, {this.state.state}, {this.state.zip}
                            </Typography>
                            <Typography align="center" mt={1}>
                                Reservation #{this.props.reservationId} | Date: {new Date().toLocaleDateString()}
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="h6" gutterBottom>Guest Information</Typography>
                                    <Typography><strong>Name:</strong> {this.props.fname} {this.props.lname} </Typography>
                                    <Typography><strong>Email:</strong> {this.props.email}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="h6" gutterBottom>Reservation Details</Typography>
                                    <Typography><strong>Site #:</strong> {this.props.siteName} ({this.props.siteType})</Typography>
                                    <Typography><strong>Check-in:</strong> {this.props.checkIn} </Typography>
                                    <Typography><strong>Check-out:</strong> {this.props.checkOut} </Typography>
                                    <Typography><strong>Duration:</strong> {this.props.duration} nights</Typography>
                                    <Typography><strong>Guests:</strong> {this.props.adults} adults, {this.props.childrens} children</Typography>
                                    {this.props.rigName && <Typography><strong>Rig Name:</strong> {this.props.rigName} </Typography>}
                                    {this.props.slides>0 && <Typography><strong>Slides:</strong> {this.props.slides} </Typography>}
                                    {this.props.rigLength>0 && <Typography><strong>Rig Length:</strong> {this.props.rigLength} </Typography>}
                                    {this.props.siteLength>0 && <Typography><strong>Site Length:</strong> {this.props.siteLength} </Typography> }
                                    {this.props.boatType>0 && <Typography><strong>Boat Type:</strong> {this.props.boatType} </Typography>}
                                    {this.props.boatDraft>0 && <Typography><strong>Boat Draft:</strong> {this.props.boatDraft} </Typography>}
                                    {this.props.boatLength>0 && <Typography><strong>Boat Length:</strong> {this.props.boatLength} </Typography>}
                                    {this.props.boatBeam>0 && <Typography><strong>Boat Beam:</strong> {this.props.boatBeam} </Typography>}
                                    {this.props.freshWater>0 && <Typography><strong>Fresh Water</strong></Typography>}
                                    {this.props.pumpOut>0 && <Typography><strong>Pump out</strong></Typography>}
                                    {this.props.e15a>0 && <Typography><strong>15 amp</strong></Typography>}
                                    {this.props.e30a>0 && <Typography><strong>30 amp</strong></Typography>}
                                    {this.props.e50a>0 && <Typography><strong>50 amp</strong></Typography>}
                                    {this.props.e100a>0 && <Typography><strong>100 amp</strong></Typography>}
                                    
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 3 }} />

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Description</strong></TableCell>
                                        <TableCell><strong>Quantity</strong></TableCell>
                                        {!this.props.blended && <TableCell><strong>Rate</strong></TableCell>}
                                        <TableCell><strong>Amount</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.props.months > 0
                                        ?
                                        <TableRow>
                                            <TableCell>Months</TableCell>
                                            <TableCell>{this.props.months}</TableCell>
                                            {!this.props.blended && <TableCell>${this.props.monthly}</TableCell>}
                                            <TableCell>${!this.props.seasonal?(!isNaN(this.props.monthsTotal)?this.props.monthsTotal:''):''}</TableCell>
                                        </TableRow>
                                        : null
                                    }
                                    {this.props.weeks > 0
                                        ?
                                        <TableRow>
                                            <TableCell>Weeks</TableCell>
                                            <TableCell>{this.props.weeks}</TableCell>
                                            {!this.props.blended && <TableCell>${this.props.weekly}</TableCell>}
                                            <TableCell>${!this.props.seasonal?(!isNaN(this.props.weeksTotal)?this.props.weeksTotal:''):''}</TableCell>
                                        </TableRow>
                                        : null
                                    }
                                    {this.props.days > 0
                                        ?
                                        <TableRow>
                                            <TableCell>Days</TableCell>
                                            <TableCell>{this.props.days}</TableCell>
                                            {!this.props.blended && <TableCell>${this.props.daily}</TableCell>}
                                            <TableCell>${!this.props.seasonal?(!isNaN(this.props.daysTotal)?this.props.daysTotal:''):''}</TableCell>
                                        </TableRow>
                                        : null
                                    }
                                    {this.props.discount > 0
                                        ?
                                        <TableRow>
                                            <TableCell>Discount</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>${this.props.discount}</TableCell>
                                        </TableRow>
                                        : null
                                    }
                                    {this.props.oneTimeDiscount > 0
                                        ?
                                        <TableRow>
                                            <TableCell>One Time Discount</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>-${this.props.oneTimeDiscount}</TableCell>
                                        </TableRow>
                                        : null
                                    }
                                    {Array.isArray(this.props.selectedExtras) && this.props.selectedExtras.length > 0
                                        ? <>
                                            {this.props.selectedExtras.map((extraName, index) => (
                                                <TableRow>
                                                    <TableCell>{extraName}</TableCell>
                                                    <TableCell>{this.props.selectedExtraCount[index]}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell>${parseFloat(this.props.selectedExtraAmount[index]).toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                        : null
                                    }
                                    {this.props.variableCharges.length > 0
                                        ?
                                        <>
                                            {this.props.variableCharges.map((variableCharge, index) => (
                                                <TableRow>
                                                    <TableCell>{variableCharge.detail}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell>${parseFloat(variableCharge.amount).toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                        : null
                                    }
                                </TableBody>
                            </Table>

                            <Box mt={2} textAlign="right">
                                <Typography>Subtotal: ${!isNaN(this.props.subtotal) ? this.props.subtotal : this.props.total}</Typography>
                                {this.props.serviceFees > 0
                                    ?
                                    <Typography>Service Fees: ${this.props.serviceFees}</Typography>
                                    : null
                                }
                                {this.props.taxName.map((taxName, index) => (
                                    <Typography>{taxName} : ${this.props.tax[index]}</Typography>
                                ))}

                                <Typography variant="h6" fontWeight="bold" mt={2}>
                                    Total: ${!isNaN(this.props.totalAmount) ? (this.props.totalAmount) : (this.props.total + this.props.tax_amount)}
                                </Typography>

                                {this.props.payments.length > 0
                                    ? <>
                                        {this.props.payments.map((payment, index) => (
                                            <Typography>
                                                {payment.memo} ({payment.created_at.slice(0, 10)}) : ${parseFloat(payment.amount).toFixed(2)}
                                            </Typography>
                                        ))}
                                    </>
                                    : null
                                }

                                <Typography variant="h6" mt={1}>
                                    Balance Due: ${!isNaN(this.props.balanceDue)?this.props.balanceDue:(this.props.total + this.props.tax_amount - this.props.amount_paid)}
                                </Typography>
                            </Box>

                            <Divider sx={{ my: 3 }} />

                            <Typography variant="subtitle1" fontWeight="bold">
                                Policies & Information:
                            </Typography>
                            <Typography style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                {this.state.rules}
                            </Typography>

                            <Divider sx={{ my: 3 }} />
                            <Box sx={{ mt: 4, textAlign: 'center' }}>
                                <Typography variant="body1" color="text.secondary" gutterBottom>
                                    Thank you for choosing {this.state.companyName}!
                                </Typography>

                                <Typography variant="body1" color="text.secondary" gutterBottom>
                                    This receipt was generated on {new Date().toLocaleString()}.
                                </Typography>

                                <Divider sx={{ mt: 10, mb: 1, mx: 'auto', width: '50%' }} />
                                <Typography >
                                    (Signature)
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    {this.props.fname} {this.props.lname}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </ThemeProvider>
        );
    }
}

export default PrintReservation;